const Logo = () => {
  return (
    <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
      <span className="text-purple-600 font-bold text-lg">
        L
      </span>
    </div>
  );
}

export default Logo